
import request from '@/shared/apis'

// Field type constants
export const FieldType = {
  TEXT: 'TEXT',
  MULTI_TEXT: 'MULTI_TEXT',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  SINGLE_SELECT: 'SINGLE_SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  TEXTAREA: 'TEXTAREA',
  RATING: 'RATING'
};

const getBaseApiUrl = (sectionId) => {
  return `/aper-sections/${sectionId}/fields`;
};

const getFieldApiUrl = (fieldId) => {
  return `/aper-fields/${fieldId}`;
};

/**
 * Get all fields for a section
 * @param sectionId The ID of the section to get fields for
 */
export const getFieldsBySection = async (sectionId) => {
  return await request.get(getBaseApiUrl(sectionId));
};

/**
 * Get a specific field by ID
 * @param sectionId The ID of the section that contains the field
 * @param fieldId The ID of the field to get
 */
export const getField = async (sectionId, fieldId) => {
  return await request.get(`${getBaseApiUrl(sectionId)}/${fieldId}`);
};

/**
 * Create a new field in a section
 * @param sectionId The ID of the section to create the field in
 * @param data The field data to create
 */
export const createField = async (sectionId, data) => {
  return await request.post(getBaseApiUrl(sectionId), data);
};

/**
 * Update an existing field
 * @param sectionId The ID of the section that contains the field
 * @param fieldId The ID of the field to update
 * @param data The updated field data
 */
export const updateField = async (sectionId, fieldId, data) => {
  return await request.put(`${getBaseApiUrl(sectionId)}/${fieldId}`, data);
};

/**
 * Delete a field
 * @param sectionId The ID of the section that contains the field
 * @param fieldId The ID of the field to delete
 */
export const deleteField = async (sectionId, fieldId) => {
  return await request.delete(`${getBaseApiUrl(sectionId)}/${fieldId}`);
};

/**
 * Reorder fields within a section
 * @param sectionId The ID of the section containing the fields
 * @param fieldIds An array of field IDs in their new order
 */
export const reorderFields = async (sectionId, fieldIds) => {
  return await request.put(`${getBaseApiUrl(sectionId)}/reorder`, { fieldIds });
};

/**
 * Helper function to create field options for selection-type fields
 * @param fieldId The ID of the field to create options for
 * @param options The options to create
 */
export const createFieldOptions = async (fieldId, data) => {
  return await request.post(`${getFieldApiUrl(fieldId)}/options`, data);
};

/**
 * Helper function to update field options
 * @param fieldId The ID of the field containing the options
 * @param options The updated options
 */
export const updateFieldOptions = async (fieldId, data) => {
  return await request.put(`${getFieldApiUrl(fieldId)}/options`, data);
};

/**
 * Helper function to create text templates for MULTI_TEXT fields
 * @param fieldId The ID of the field to create templates for
 * @param templates The templates to create
 */
export const createTextTemplates = async (fieldId, data) => {
  return await request.post(`${getFieldApiUrl(fieldId)}/text-templates`, data);
};

/**
 * Helper function to update text templates
 * @param fieldId The ID of the field containing the templates
 * @param templates The updated templates
 */
export const updateTextTemplates = async (fieldId, data) => {
  return await request.put(`${getFieldApiUrl(fieldId)}/text-templates`, data);
};
